var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},[_c('div',{staticClass:"fields"},_vm._l((_vm.fields),function(field){return _c('field',_vm._b({key:field.name,on:{"event":_vm.event}},'field',[field, {alt: _vm.fieldAlt}],false))}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }